import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Offer() {
  return <section id="offer" className="py-16 md:py-24 px-4 md:px-6" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <FadeIn data-id="element-87">
          <div className="bg-ivory-100 border-2 border-emerald-900 p-6 sm:p-8 md:p-14 rounded-sm shadow-2xl relative overflow-hidden" data-id="element-88">
            {/* Decorative corners — gold accents */}
            <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-12 border-t-2 border-l-2 border-gold m-2 md:m-3 opacity-60 pointer-events-none" data-id="element-89" />
            <div className="absolute top-0 right-0 w-10 h-10 md:w-12 md:h-12 border-t-2 border-r-2 border-gold m-2 md:m-3 opacity-60 pointer-events-none" data-id="element-90" />
            <div className="absolute bottom-0 left-0 w-10 h-10 md:w-12 md:h-12 border-b-2 border-l-2 border-gold m-2 md:m-3 opacity-60 pointer-events-none" data-id="element-91" />
            <div className="absolute bottom-0 right-0 w-10 h-10 md:w-12 md:h-12 border-b-2 border-r-2 border-gold m-2 md:m-3 opacity-60 pointer-events-none" data-id="element-92" />

            {/* Eyebrow */}
            <div className="text-center mb-5 md:mb-6" data-id="element-93">
              <div className="inline-flex items-center gap-3" data-id="element-94">
                <div className="h-px w-6 md:w-8 bg-gold" data-id="element-95" />
                <span className="text-gold font-sans text-[10px] md:text-xs font-bold tracking-[0.25em] uppercase" data-id="element-96">
                  A Private Invitation
                </span>
                <div className="h-px w-6 md:w-8 bg-gold" data-id="element-97" />
              </div>
            </div>

            {/* Product Title */}
            <h2 className="text-2xl md:text-3xl font-serif text-emerald-900 mb-3 md:mb-4 leading-tight text-center" data-id="element-98">
              The Italy Insider Protocol Guide
            </h2>

            {/* Feature list */}
            <p className="text-xs sm:text-sm md:text-base text-charcoal/70 font-sans font-light mb-6 md:mb-8 text-center max-w-xl mx-auto leading-relaxed" data-id="element-99">
              Digital Tactical Guide · The "No-Tax" Script Vault · Cultural
              Heritage Framework
            </p>

            {/* Pricing — kept exactly as is */}
            <div className="flex items-baseline justify-center gap-3 md:gap-4 mb-2" data-id="element-100">
              <span className="font-serif text-2xl md:text-3xl text-charcoal/40 line-through decoration-1" data-id="element-101">
                $99
              </span>
              <span className="font-serif text-6xl md:text-7xl text-emerald-900 font-bold tracking-tight" data-id="element-102">
                $19
              </span>
            </div>
            <p className="text-center text-[10px] md:text-xs text-charcoal/60 font-sans uppercase tracking-[0.2em] mb-6 md:mb-8" data-id="element-103">
              USD · One-Time Investment
            </p>

            {/* CTA — now above the fold */}
            <div className="text-center" data-id="element-104">
              <Button href="https://themodernprotocols.com/cart/47838889804002:1" className="w-full sm:w-auto text-base md:text-xl py-4 md:py-5 px-8 md:px-14 mb-4 uppercase tracking-[0.15em]" style={{
              color: '#C9A961'
            }} data-id="element-105">
                Unlock My Insider Access Now
              </Button>

              <p className="text-[11px] md:text-xs text-charcoal/60 font-sans tracking-wider" data-id="element-106">
                Immediate digital delivery
              </p>
            </div>

            {/* Thin gold divider — now a separator before supporting copy */}
            <div className="flex items-center justify-center gap-3 my-8 md:my-10" data-id="element-107">
              <div className="h-px w-16 bg-gold/40" data-id="element-108" />
              <div className="w-1.5 h-1.5 rotate-45 bg-gold/60" data-id="element-109" />
              <div className="h-px w-16 bg-gold/40" data-id="element-110" />
            </div>

            {/* Cost framing intro — moved below as supporting body copy */}
            <p className="text-sm md:text-base text-charcoal/75 font-serif italic leading-relaxed text-center max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-111">
              The cost of an "un-protocol" trip is high. It's the €50 "tourist
              surcharge" on a taxi, the €100 spent on a dinner that felt like a
              transaction rather than an event, and the hours of stress
              navigating a system that feels designed to keep you on the
              outside.
            </p>

            {/* Trust badges */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-[10px] text-charcoal/50 font-sans uppercase tracking-[0.2em] pt-6 border-t border-gold/15" data-id="element-112">
              <span className="flex items-center gap-2" data-id="element-113">
                <div className="w-1 h-1 rounded-full bg-gold" data-id="element-114" /> Secure Checkout
              </span>
              <span className="flex items-center gap-2" data-id="element-115">
                <div className="w-1 h-1 rounded-full bg-gold" data-id="element-116" /> Lifetime Access
              </span>
              <span className="flex items-center gap-2" data-id="element-117">
                <div className="w-1 h-1 rounded-full bg-gold" data-id="element-118" /> Mobile
                Optimized
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}